import React from "react";
import { Box, Flex, Heading, Spacer, Text } from "@chakra-ui/react";

/**
 * Standard layout for list pages across the app.
 * Critical: overflowX="hidden" prevents page-level horizontal scrolling.
 */
const ListPageLayout = ({ title, description, actions, children, contentProps = {} }) => {
  return (
    <Box mx="auto" p={6} w="100%" maxW="100%" overflowX="hidden">
      <Flex align="center" mb={6} gap={4} flexWrap="wrap">
        <Box>
          <Heading as="h2" size="lg">
            {title}
          </Heading>
          {description ? (
            <Text mt={1} color="gray.500">
              {description}
            </Text>
          ) : null}
        </Box>

        <Spacer />

        {actions}
      </Flex>

      <Box w="100%" maxW="100%" {...contentProps}>
        {children}
      </Box>
    </Box>
  );
};

export default ListPageLayout;
